// Fase 2, W15: módulo Equipe (chat da equipe no menu Comunicação), em pt, en e es.
const pt = {
  nome: 'Equipe',
  abas: { chat: 'Chat da equipe' },
  selo: { naoLidas_one: '{{count}} mensagem não lida', naoLidas_other: '{{count}} mensagens não lidas' },
  acoes: {
    novaConversa: 'Nova conversa',
    canaisPublicos: 'Canais públicos',
    entrar: 'Entrar no canal',
    abrir: 'Abrir',
    criar: 'Criar',
    salvar: 'Salvar',
    adicionar: 'Adicionar',
    participantes: 'Participantes',
    editar: 'Editar canal',
    sair: 'Sair do canal',
    arquivar: 'Arquivar canal',
    desarquivar: 'Desarquivar canal',
    acoesCanal: 'Ações do canal',
    abrirRegistro: 'Abrir o registro',
    voltar: 'Voltar para a lista',
  },
  tipos: { departamento: 'Departamento', grupo: 'Grupo', direta: 'Conversa direta', registro: 'Discussão de registro' },
  visibilidade: { publico: 'Público', privado: 'Privado', publicoAjuda: 'Todo o time vê e pode entrar', privadoAjuda: 'Só quem participa vê' },
  papeis: { dono: 'Dono', membro: 'Membro' },
  lista: {
    buscar: 'Buscar conversas e mensagens',
    filtros: 'Filtrar conversas',
    todas: 'Todas',
    naoLidas: 'Não lidas',
    diretas: 'Diretas',
    grupos: 'Grupos',
    departamentos: 'Departamentos',
    arquivadas: 'Arquivadas',
    conversas: 'Conversas',
    mensagens: 'Mensagens encontradas',
    vaziaTitulo: 'Nenhuma conversa ainda',
    vaziaTexto: 'Converse com alguém do time sem sair do sistema: comece uma conversa direta ou crie um grupo.',
    vaziaFiltro: 'Nenhuma conversa neste filtro.',
    semResultado: 'Nada encontrado com esta busca.',
    semMensagens: 'Sem mensagens ainda',
    voce: 'Você',
    anexo_one: '{{count}} anexo',
    anexo_other: '{{count}} anexos',
    apagada: 'Mensagem apagada',
    naoLidas_one: '{{count}} não lida',
    naoLidas_other: '{{count}} não lidas',
    membros_one: '{{count}} participante',
    membros_other: '{{count}} participantes',
  },
  painel: {
    escolhaTitulo: 'Escolha uma conversa',
    escolha: 'As conversas diretas, os grupos e os canais de departamento ficam à esquerda.',
    semMensagensTitulo: 'Comece a conversa',
    semMensagens: 'Mande a primeira mensagem. Use @ para chamar alguém do canal.',
    carregarAnteriores: 'Carregar mensagens anteriores',
    novas: 'Novas mensagens',
    discussaoDe: 'Discussão de {{entidade}}',
    publicoAviso: 'Você está lendo um canal público. Entre para escrever.',
    arquivadoAviso: 'Canal arquivado: só leitura.',
    semEnvio: 'Você pode ler, mas não enviar mensagens.',
    naoEncontrado: 'Esta conversa não existe mais ou você não participa dela.',
  },
  mensagem: {
    apagada: 'Mensagem apagada',
    editada: 'editada',
    viaAgente: 'pelo assistente',
    acoes: 'Ações da mensagem',
    responder: 'Responder',
    editar: 'Editar',
    apagar: 'Apagar',
    respondendo: 'Respondendo a {{nome}}',
    cancelarResposta: 'Cancelar a resposta',
    anexo: 'Anexo',
    salvar: 'Salvar',
    cancelar: 'Cancelar',
    editarRotulo: 'Editar a mensagem',
    apagarTitulo: 'Apagar a mensagem?',
    apagarTexto: 'A mensagem some para todos e fica "Mensagem apagada", sem o texto e sem os anexos. Não dá para desfazer.',
    abrirImagem: 'Abrir a imagem {{nome}}',
    baixar: 'Baixar {{nome}}',
  },
  composer: {
    placeholder: 'Escreva uma mensagem',
    rotulo: 'Mensagem para {{canal}}',
    dica: 'Enter envia, Shift+Enter quebra a linha, @ chama alguém do canal',
    anexar: 'Anexar arquivo',
    limite: 'Até 25 MB por arquivo; o tipo é conferido no envio',
    enviando: 'Enviando arquivo',
    remover: 'Remover {{nome}}',
    enviar: 'Enviar',
    pessoas: 'Pessoas do canal',
    mencionados: 'Vão receber aviso: {{nomes}}',
  },
  sistema: {
    criou: '{{ator}} criou o canal {{nome}}',
    entrou: '{{ator}} entrou no canal',
    saiu: '{{ator}} saiu do canal',
    adicionou: '{{ator}} adicionou {{alvos}}',
    removeu: '{{ator}} retirou {{alvos}}',
    renomeou: '{{ator}} renomeou o canal para {{nome}}',
    publico: '{{ator}} tornou o canal público',
    privado: '{{ator}} tornou o canal privado',
    arquivou: '{{ator}} arquivou o canal',
    desarquivou: '{{ator}} desarquivou o canal',
    promoveu: '{{ator}} tornou {{alvos}} dono do canal',
    rebaixou: '{{ator}} tornou {{alvos}} membro do canal',
    discussao: '{{ator}} abriu a discussão deste registro',
  },
  nova: {
    titulo: 'Nova conversa',
    tipo: 'Tipo de conversa',
    diretaTexto: 'Escolha com quem conversar. A conversa fica só entre vocês dois.',
    grupoTexto: 'Um grupo para um assunto, um projeto ou um time. Você fica como dono.',
    departamentoTexto: 'Canal de um departamento. Os funcionários ativos do departamento com acesso ao sistema entram nele.',
    nome: 'Nome',
    descricao: 'Descrição (opcional)',
    visibilidade: 'Quem vê',
    participantes: 'Participantes',
    departamento: 'Departamento do Pessoas',
    semDepartamento: 'Sem departamento (só o nome)',
    buscarPessoa: 'Buscar pessoa',
    nenhumaPessoa: 'Ninguém encontrado',
    semPessoas: 'Ainda não há outras pessoas com acesso ao chat.',
    selecionadas_one: '{{count}} pessoa escolhida',
    selecionadas_other: '{{count}} pessoas escolhidas',
    recusados: 'Não puderam entrar (sem acesso ao chat, ao registro ou à empresa do canal): {{nomes}}',
  },
  membros: {
    titulo: 'Participantes de {{canal}}',
    adicionar: 'Adicionar pessoas',
    nenhumParaAdicionar: 'Todas as pessoas com acesso ao chat já participam.',
    tornarDono: 'Tornar dono',
    tornarMembro: 'Tornar membro',
    remover: 'Retirar do canal',
    acoesDe: 'Ações para {{nome}}',
    voce: '(você)',
    sairTitulo: 'Sair do canal?',
    sairTexto: 'Você deixa de receber as mensagens. Num canal privado, só volta se alguém adicionar você.',
    removerTitulo: 'Retirar {{nome}} do canal?',
    removerTexto: 'A pessoa deixa de ver as mensagens deste canal.',
    arquivarTitulo: 'Arquivar o canal?',
    arquivarTexto: 'O canal sai da lista principal e fica só leitura. Quem participa ainda encontra o histórico em Arquivadas.',
  },
  explorar: {
    titulo: 'Canais públicos',
    texto: 'Canais abertos a todo o time. Leia sem entrar ou entre para escrever.',
    vazio: 'Nenhum canal público ainda.',
    participa: 'Você participa',
  },
  editar: { titulo: 'Editar canal' },
};

const en: typeof pt = {
  nome: 'Team',
  abas: { chat: 'Team chat' },
  selo: { naoLidas_one: '{{count}} unread message', naoLidas_other: '{{count}} unread messages' },
  acoes: {
    novaConversa: 'New conversation',
    canaisPublicos: 'Public channels',
    entrar: 'Join channel',
    abrir: 'Open',
    criar: 'Create',
    salvar: 'Save',
    adicionar: 'Add',
    participantes: 'Members',
    editar: 'Edit channel',
    sair: 'Leave channel',
    arquivar: 'Archive channel',
    desarquivar: 'Unarchive channel',
    acoesCanal: 'Channel actions',
    abrirRegistro: 'Open the record',
    voltar: 'Back to the list',
  },
  tipos: { departamento: 'Department', grupo: 'Group', direta: 'Direct conversation', registro: 'Record discussion' },
  visibilidade: { publico: 'Public', privado: 'Private', publicoAjuda: 'The whole team sees it and can join', privadoAjuda: 'Only members see it' },
  papeis: { dono: 'Owner', membro: 'Member' },
  lista: {
    buscar: 'Search conversations and messages',
    filtros: 'Filter conversations',
    todas: 'All',
    naoLidas: 'Unread',
    diretas: 'Direct',
    grupos: 'Groups',
    departamentos: 'Departments',
    arquivadas: 'Archived',
    conversas: 'Conversations',
    mensagens: 'Messages found',
    vaziaTitulo: 'No conversations yet',
    vaziaTexto: 'Talk to someone on the team without leaving the system: start a direct conversation or create a group.',
    vaziaFiltro: 'No conversations in this filter.',
    semResultado: 'Nothing found for this search.',
    semMensagens: 'No messages yet',
    voce: 'You',
    anexo_one: '{{count}} attachment',
    anexo_other: '{{count}} attachments',
    apagada: 'Message deleted',
    naoLidas_one: '{{count}} unread',
    naoLidas_other: '{{count}} unread',
    membros_one: '{{count}} member',
    membros_other: '{{count}} members',
  },
  painel: {
    escolhaTitulo: 'Pick a conversation',
    escolha: 'Direct conversations, groups and department channels are on the left.',
    semMensagensTitulo: 'Start the conversation',
    semMensagens: 'Send the first message. Use @ to call someone in the channel.',
    carregarAnteriores: 'Load earlier messages',
    novas: 'New messages',
    discussaoDe: 'Discussion of {{entidade}}',
    publicoAviso: 'You are reading a public channel. Join to write.',
    arquivadoAviso: 'Archived channel: read only.',
    semEnvio: 'You can read, but not send messages.',
    naoEncontrado: 'This conversation no longer exists or you are not in it.',
  },
  mensagem: {
    apagada: 'Message deleted',
    editada: 'edited',
    viaAgente: 'by the assistant',
    acoes: 'Message actions',
    responder: 'Reply',
    editar: 'Edit',
    apagar: 'Delete',
    respondendo: 'Replying to {{nome}}',
    cancelarResposta: 'Cancel the reply',
    anexo: 'Attachment',
    salvar: 'Save',
    cancelar: 'Cancel',
    editarRotulo: 'Edit the message',
    apagarTitulo: 'Delete the message?',
    apagarTexto: 'The message disappears for everyone and shows "Message deleted", without the text and attachments. This cannot be undone.',
    abrirImagem: 'Open the image {{nome}}',
    baixar: 'Download {{nome}}',
  },
  composer: {
    placeholder: 'Write a message',
    rotulo: 'Message to {{canal}}',
    dica: 'Enter sends, Shift+Enter adds a line, @ calls someone in the channel',
    anexar: 'Attach file',
    limite: 'Up to 25 MB per file; the type is checked on upload',
    enviando: 'Uploading file',
    remover: 'Remove {{nome}}',
    enviar: 'Send',
    pessoas: 'People in the channel',
    mencionados: 'Will be notified: {{nomes}}',
  },
  sistema: {
    criou: '{{ator}} created the channel {{nome}}',
    entrou: '{{ator}} joined the channel',
    saiu: '{{ator}} left the channel',
    adicionou: '{{ator}} added {{alvos}}',
    removeu: '{{ator}} removed {{alvos}}',
    renomeou: '{{ator}} renamed the channel to {{nome}}',
    publico: '{{ator}} made the channel public',
    privado: '{{ator}} made the channel private',
    arquivou: '{{ator}} archived the channel',
    desarquivou: '{{ator}} unarchived the channel',
    promoveu: '{{ator}} made {{alvos}} an owner of the channel',
    rebaixou: '{{ator}} made {{alvos}} a member of the channel',
    discussao: '{{ator}} opened the discussion of this record',
  },
  nova: {
    titulo: 'New conversation',
    tipo: 'Conversation type',
    diretaTexto: 'Pick who to talk to. The conversation stays between the two of you.',
    grupoTexto: 'A group for a subject, a project or a team. You become the owner.',
    departamentoTexto: 'A department channel. Active employees of the department with system access join it.',
    nome: 'Name',
    descricao: 'Description (optional)',
    visibilidade: 'Who sees it',
    participantes: 'Members',
    departamento: 'Department in People',
    semDepartamento: 'No department (name only)',
    buscarPessoa: 'Search person',
    nenhumaPessoa: 'No one found',
    semPessoas: 'There are no other people with chat access yet.',
    selecionadas_one: '{{count}} person selected',
    selecionadas_other: '{{count}} people selected',
    recusados: 'Could not join (no access to the chat, the record or the channel company): {{nomes}}',
  },
  membros: {
    titulo: 'Members of {{canal}}',
    adicionar: 'Add people',
    nenhumParaAdicionar: 'Everyone with chat access is already a member.',
    tornarDono: 'Make owner',
    tornarMembro: 'Make member',
    remover: 'Remove from channel',
    acoesDe: 'Actions for {{nome}}',
    voce: '(you)',
    sairTitulo: 'Leave the channel?',
    sairTexto: 'You stop receiving its messages. In a private channel, you only come back if someone adds you.',
    removerTitulo: 'Remove {{nome}} from the channel?',
    removerTexto: 'The person stops seeing the messages of this channel.',
    arquivarTitulo: 'Archive the channel?',
    arquivarTexto: 'The channel leaves the main list and becomes read only. Members still find the history under Archived.',
  },
  explorar: {
    titulo: 'Public channels',
    texto: 'Channels open to the whole team. Read without joining or join to write.',
    vazio: 'No public channels yet.',
    participa: 'You are a member',
  },
  editar: { titulo: 'Edit channel' },
};

const es: typeof pt = {
  nome: 'Equipo',
  abas: { chat: 'Chat del equipo' },
  selo: { naoLidas_one: '{{count}} mensaje sin leer', naoLidas_other: '{{count}} mensajes sin leer' },
  acoes: {
    novaConversa: 'Nueva conversación',
    canaisPublicos: 'Canales públicos',
    entrar: 'Unirse al canal',
    abrir: 'Abrir',
    criar: 'Crear',
    salvar: 'Guardar',
    adicionar: 'Agregar',
    participantes: 'Participantes',
    editar: 'Editar canal',
    sair: 'Salir del canal',
    arquivar: 'Archivar canal',
    desarquivar: 'Desarchivar canal',
    acoesCanal: 'Acciones del canal',
    abrirRegistro: 'Abrir el registro',
    voltar: 'Volver a la lista',
  },
  tipos: { departamento: 'Departamento', grupo: 'Grupo', direta: 'Conversación directa', registro: 'Discusión de registro' },
  visibilidade: { publico: 'Público', privado: 'Privado', publicoAjuda: 'Todo el equipo lo ve y puede unirse', privadoAjuda: 'Solo lo ven los participantes' },
  papeis: { dono: 'Dueño', membro: 'Miembro' },
  lista: {
    buscar: 'Buscar conversaciones y mensajes',
    filtros: 'Filtrar conversaciones',
    todas: 'Todas',
    naoLidas: 'Sin leer',
    diretas: 'Directas',
    grupos: 'Grupos',
    departamentos: 'Departamentos',
    arquivadas: 'Archivadas',
    conversas: 'Conversaciones',
    mensagens: 'Mensajes encontrados',
    vaziaTitulo: 'Aún no hay conversaciones',
    vaziaTexto: 'Habla con alguien del equipo sin salir del sistema: empieza una conversación directa o crea un grupo.',
    vaziaFiltro: 'No hay conversaciones en este filtro.',
    semResultado: 'No se encontró nada con esta búsqueda.',
    semMensagens: 'Aún no hay mensajes',
    voce: 'Tú',
    anexo_one: '{{count}} adjunto',
    anexo_other: '{{count}} adjuntos',
    apagada: 'Mensaje borrado',
    naoLidas_one: '{{count}} sin leer',
    naoLidas_other: '{{count}} sin leer',
    membros_one: '{{count}} participante',
    membros_other: '{{count}} participantes',
  },
  painel: {
    escolhaTitulo: 'Elige una conversación',
    escolha: 'Las conversaciones directas, los grupos y los canales de departamento están a la izquierda.',
    semMensagensTitulo: 'Empieza la conversación',
    semMensagens: 'Envía el primer mensaje. Usa @ para llamar a alguien del canal.',
    carregarAnteriores: 'Cargar mensajes anteriores',
    novas: 'Mensajes nuevos',
    discussaoDe: 'Discusión de {{entidade}}',
    publicoAviso: 'Estás leyendo un canal público. Únete para escribir.',
    arquivadoAviso: 'Canal archivado: solo lectura.',
    semEnvio: 'Puedes leer, pero no enviar mensajes.',
    naoEncontrado: 'Esta conversación ya no existe o no participas de ella.',
  },
  mensagem: {
    apagada: 'Mensaje borrado',
    editada: 'editado',
    viaAgente: 'por el asistente',
    acoes: 'Acciones del mensaje',
    responder: 'Responder',
    editar: 'Editar',
    apagar: 'Borrar',
    respondendo: 'Respondiendo a {{nome}}',
    cancelarResposta: 'Cancelar la respuesta',
    anexo: 'Adjunto',
    salvar: 'Guardar',
    cancelar: 'Cancelar',
    editarRotulo: 'Editar el mensaje',
    apagarTitulo: '¿Borrar el mensaje?',
    apagarTexto: 'El mensaje desaparece para todos y queda "Mensaje borrado", sin el texto ni los adjuntos. No se puede deshacer.',
    abrirImagem: 'Abrir la imagen {{nome}}',
    baixar: 'Descargar {{nome}}',
  },
  composer: {
    placeholder: 'Escribe un mensaje',
    rotulo: 'Mensaje para {{canal}}',
    dica: 'Enter envía, Shift+Enter agrega una línea, @ llama a alguien del canal',
    anexar: 'Adjuntar archivo',
    limite: 'Hasta 25 MB por archivo; el tipo se verifica al enviar',
    enviando: 'Enviando archivo',
    remover: 'Quitar {{nome}}',
    enviar: 'Enviar',
    pessoas: 'Personas del canal',
    mencionados: 'Recibirán aviso: {{nomes}}',
  },
  sistema: {
    criou: '{{ator}} creó el canal {{nome}}',
    entrou: '{{ator}} se unió al canal',
    saiu: '{{ator}} salió del canal',
    adicionou: '{{ator}} agregó a {{alvos}}',
    removeu: '{{ator}} quitó a {{alvos}}',
    renomeou: '{{ator}} cambió el nombre del canal a {{nome}}',
    publico: '{{ator}} hizo público el canal',
    privado: '{{ator}} hizo privado el canal',
    arquivou: '{{ator}} archivó el canal',
    desarquivou: '{{ator}} desarchivó el canal',
    promoveu: '{{ator}} hizo dueño del canal a {{alvos}}',
    rebaixou: '{{ator}} hizo miembro del canal a {{alvos}}',
    discussao: '{{ator}} abrió la discusión de este registro',
  },
  nova: {
    titulo: 'Nueva conversación',
    tipo: 'Tipo de conversación',
    diretaTexto: 'Elige con quién hablar. La conversación queda solo entre tú y esa persona.',
    grupoTexto: 'Un grupo para un tema, un proyecto o un equipo. Tú quedas como dueño.',
    departamentoTexto: 'Canal de un departamento. Entran los empleados activos del departamento con acceso al sistema.',
    nome: 'Nombre',
    descricao: 'Descripción (opcional)',
    visibilidade: 'Quién lo ve',
    participantes: 'Participantes',
    departamento: 'Departamento de Personas',
    semDepartamento: 'Sin departamento (solo el nombre)',
    buscarPessoa: 'Buscar persona',
    nenhumaPessoa: 'No se encontró a nadie',
    semPessoas: 'Aún no hay otras personas con acceso al chat.',
    selecionadas_one: '{{count}} persona elegida',
    selecionadas_other: '{{count}} personas elegidas',
    recusados: 'No pudieron unirse (sin acceso al chat, al registro o a la empresa del canal): {{nomes}}',
  },
  membros: {
    titulo: 'Participantes de {{canal}}',
    adicionar: 'Agregar personas',
    nenhumParaAdicionar: 'Todas las personas con acceso al chat ya participan.',
    tornarDono: 'Hacer dueño',
    tornarMembro: 'Hacer miembro',
    remover: 'Quitar del canal',
    acoesDe: 'Acciones para {{nome}}',
    voce: '(tú)',
    sairTitulo: '¿Salir del canal?',
    sairTexto: 'Dejas de recibir sus mensajes. En un canal privado, solo vuelves si alguien te agrega.',
    removerTitulo: '¿Quitar a {{nome}} del canal?',
    removerTexto: 'La persona deja de ver los mensajes de este canal.',
    arquivarTitulo: '¿Archivar el canal?',
    arquivarTexto: 'El canal sale de la lista principal y queda solo lectura. Los participantes aún encuentran el historial en Archivadas.',
  },
  explorar: {
    titulo: 'Canales públicos',
    texto: 'Canales abiertos a todo el equipo. Lee sin unirte o únete para escribir.',
    vazio: 'Aún no hay canales públicos.',
    participa: 'Participas',
  },
  editar: { titulo: 'Editar canal' },
};

export const i18n = { pt, en, es };
